export default "__VITE_ASSET__DnQMe5yh__"